import { Customer } from '@/schema/graphql'
import React, { createContext, useContext, useState, useEffect } from 'react'

interface ResellerManagementProps {
  managingCustomer: Customer | null
  setManagingCustomer: (customer: Customer) => void
  clearManagingCustomer: () => void
}

const ResellerManagementCookieName = 'managing_customer'

const ResellerManagementContext = createContext<
  ResellerManagementProps | undefined
>(undefined)

export const ResellerManagementProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [customer, setCustomer] = useState<Customer | null>(null)

  useEffect(() => {
    const storedData = localStorage.getItem(ResellerManagementCookieName)
    if (storedData) {
      const user = JSON.parse(storedData) as Customer
      setCustomer(user)
    }
  }, [])

  const setManagingCustomer = (customer: Customer) => {
    setCustomer(customer)
    localStorage.setItem(ResellerManagementCookieName, JSON.stringify(customer))
    window.location.reload()
  }

  const clearManagingCustomer = () => {
    setCustomer(null)
    localStorage.removeItem(ResellerManagementCookieName)
    window.location.reload()
  }

  return (
    <ResellerManagementContext.Provider
      value={{
        managingCustomer: customer,
        setManagingCustomer,
        clearManagingCustomer,
      }}
    >
      {children}
    </ResellerManagementContext.Provider>
  )
}

export const useManagingCustomer = () => {
  const context = useContext(ResellerManagementContext)
  if (context === undefined) {
    throw new Error(
      'useManagingCustomer must be used within an ResellerManagementProvider'
    )
  }
  return context
}
